import { getAuthenticated } from '../../../../services/RestTemplate';
import { alertsApi } from '../../alerts/list/redux/backend';
import { objToUrlParams } from '../../../../shared/helpers/url-params.helper';

const csvExport = '/csv';

export const exportCsvAlerts = params => {
    const filteredParams = objToUrlParams(params);
    const csvExportAlertUrl = alertsApi + csvExport + filteredParams;

    return getAuthenticated(csvExportAlertUrl, {}, { responseType: 'blob' });
};
